import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Customer } from 'src/app/core/models';
import {
  AuthenticationService,
  EquipmentService,
} from 'src/app/core/providers';
import { ProfileService } from 'src/app/core/providers/services/profile.service';

@Component({
  selector: 'app-customer-selection',
  templateUrl: './customer-selection.component.html',
  styleUrls: ['./customer-selection.component.scss'],
  standalone: false,
})
export class CustomerSelectionComponent implements OnInit {
  searchResults?: Array<Customer> = undefined;
  isBusy: boolean = false;
  subscriptions: Subscription[] = [];
  customers?: Array<Customer> = undefined;
  clientId: number;
  scrollContentClass: string = 'scroll-content';
  constructor(
    public profileService: ProfileService,
    public authenticationService: AuthenticationService,
    public equipmentService: EquipmentService,
    public router: Router
  ) {
    if (
      this.profileService.getSelectedCustomersIds().length > 0 ||
      this.profileService.getSelectedBranchIds().length > 0 ||
      this.profileService.getSelectedRegionIds().length > 0
    ) {
      this.scrollContentClass = 'scroll-content-filters';
    }
  }

  ngOnInit(): void {
    this.authenticationService.startSentryTransaction(
      this.router.routerState.snapshot.url
    );
    this.profileService.clearCustomerCache();
    this.clientId =
      this.authenticationService.userInfoView.SelectedClient.ClientID;
    this.subscriptions.push(
      this.profileService.customersLoaded.subscribe((customers) => {
        this.customers = customers;
        this.isBusy = false;
        this.authenticationService.finishSentryTransaction();
      })
    );
    this.subscriptions.push(
      this.profileService.selectedCustomersChanged.subscribe(
        (selectedCustomers) => {
          this.scrollContentClass =
            selectedCustomers && selectedCustomers.length === 0
              ? 'scroll-content'
              : 'scroll-content-filters';
        }
      )
    );
    this.loadCustomers();
  }

  ngOnDestroy() {
    this.equipmentService.clearCache();
    this.profileService.nextCustomerPage = 1;
    this.subscriptions.forEach((s: Subscription) => {
      s.unsubscribe();
    });
  }

  onScrollDown() {
    if (this.profileService.useCustomerSearchResults) {
      this.profileService.pageSearchedCustomers();
    } else {
      this.profileService.getCustomers();
    }
  }

  loadCustomers = () => {
    this.customers = this.profileService.customers;
    if (!this.customers) {
      this.isBusy = true;
      this.profileService.getCustomers();
    }
  };
}
